/* istanbul ignore file */
import { useArtifactStorageId } from 'domain/documents/artifactStorage/shared/useArtifactStorageId';
import { DEFAULT_ENTITY_AUTHOR } from 'domain/shared/core/constants';
import { EntityHeader } from 'framework/ui/layout';

const ArtifactStorageFileHeader = () => {
  const id = useArtifactStorageId();
  return <EntityHeader entityTitle={`Artifact Storage File: ${id}`} defaultAuthor={DEFAULT_ENTITY_AUTHOR} />;
};

export default ArtifactStorageFileHeader;
